var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Rahmen",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 106",
    style: {
      enableBackground: "new 0 0 110 106"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,21v44h40V21H35z M73,63H37V23h36V63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48,31l-2-2c-3.4,2.6-5.7,6.6-6,11.1h2.9C43.1,36.3,45,33,48,31L48,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.1,40.1H70c-0.3-4.6-2.4-8.6-5.9-11.1l-2,2C65,33,66.9,36.3,67.1,40.1L67.1,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.3,40.9c0-4.4-3-8-7.1-9v-1c0-1.1-1-2.1-2.1-2.1c-1.1,0-2.1,1-2.1,2.1v1c-4.1,1-7.1,4.6-7.1,9v7.9l-2.9,2.9 V53h24.3v-1.4l-2.9-2.9V40.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55,57.3h0.6c1-0.1,1.7-0.9,2-1.7c0.1-0.3,0.3-0.7,0.3-1.1h-5.7C52.1,56,53.4,57.3,55,57.3L55,57.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55,57.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmsDefault);
export default __webpack_public_path__ + "static/media/alarms-default.571dce8988f2f484fd61eb99cbd44cdf.svg";
export { ForwardRef as ReactComponent };